import { lazy } from 'react';

export const LazyDropboxSsoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--dropbox-sso-page" */ './dropbox-sso-page'
    ),
);
